import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBYZ6V1lDqVTYudny1R0G_iVOBGTUeEvG8",
    authDomain: "whistlertrip-5d51d.firebaseapp.com",
    projectId: "whistlertrip-5d51d",
    storageBucket: "whistlertrip-5d51d.firebasestorage.app",
    messagingSenderId: "905304006971",
    appId: "1:905304006971:web:72b9ee4a1f2f80d282971e",
    measurementId: "G-2JEP7DNXZ0"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;
